import { Link } from "react-router";
import { Mail01, File02, Package, AlertCircle, CheckCircle } from "@untitledui/icons";
import type { ActivityItem } from "@/types/activity";

const IconForType = ({ type }: { type: ActivityItem["type"] }) => {
    switch (type) {
        case "email_new_shipment_request":
            return <Mail01 className="size-5 text-brand-secondary" />;
        case "document_updated":
            return <File02 className="size-5 text-brand-secondary" />;
        case "status_update":
            return <Package className="size-5 text-brand-secondary" />;
        case "customs_issue":
            return <AlertCircle className="size-5 text-error-600" />;
        case "seal_change":
            return <CheckCircle className="size-5 text-success-600" />;
        case "resolution_invite":
            return <AlertCircle className="size-5 text-warning-600" />;
        default:
            return <Package className="size-5 text-tertiary" />;
    }
};

export const ActivityItemView = ({ item }: { item: ActivityItem }) => {
    const time = new Intl.DateTimeFormat(undefined, { hour: "2-digit", minute: "2-digit" }).format(item.timestamp);
    return (
        <div className="flex items-start gap-3">
            <div className="mt-1">
                <IconForType type={item.type} />
            </div>
            <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2">
                    <h4 className="text-sm font-medium text-primary">{item.title}</h4>
                    {!item.isRead && <span className="inline-flex h-2 w-2 rounded-full bg-brand-solid" />}
                </div>
                {item.description && (
                    <p className="mt-1 text-sm text-tertiary">{item.description}</p>
                )}
                {item.attachments && item.attachments.length > 0 && (
                    <div className="mt-2 flex flex-wrap gap-2">
                        {item.attachments.map((att, idx) => (
                            <span key={idx} className="inline-flex items-center gap-1 rounded-md bg-secondary px-2 py-1 text-xs text-tertiary ring-1 ring-secondary">
                                <File02 className="size-3" /> {att.name}
                            </span>
                        ))}
                    </div>
                )}
                {item.actions && item.actions.length > 0 && (
                    <div className="mt-3 flex flex-wrap gap-2">
                        {item.actions.map((a, idx) => (
                            <Link key={idx} to={a.href} className="inline-flex items-center justify-center gap-1.5 rounded-lg bg-brand-solid px-3 py-1.5 text-sm font-semibold dark:text-white shadow-xs-skeumorphic ring-1 ring-transparent ring-inset hover:bg-brand-solid_hover">
                                {a.label}
                            </Link>
                        ))}
                    </div>
                )}
                <div className="mt-2 text-xs text-tertiary">{time}</div>
            </div>
        </div>
    );
};

export default ActivityItemView;


